<script setup lang="ts">
    import Layout from "@/Shared/Layout.vue";
    // import { registeredComponents } from "../../home-page-init-builder";
    import { getBuilderComponents } from "@root/builder-components.ts";
    import { computed, defineAsyncComponent, ref } from "vue";
    import { Head } from "@inertiajs/vue3";
    let searchParams = computed(()=>({
        'data.pageUrl.$eq': '/home-content'
    }));
    let props = defineProps({
        homePage: {
            type: Object,
            required: false,
            default() {
                return {
                    data: {
                        metaDescription: "",
                        metaKeywords: ""
                    }
                }
            }
        }
    });
    let Cms = defineAsyncComponent(()=>import("@/components/Cms.vue"));
</script>

<template>
    <!-- <layout> -->
    <div>
        <Head>
            <title>Rothco – Military, Tactical & Outdoor Gear Trusted Since 1953</title>
            <meta name="description" :content="homePage?.data?.metaDescription ?? ''" />
            <meta name="keywords" :content="homePage?.data?.metaKeywords ?? ''" />
        </Head>
        <Cms
            content-prop="homePage"
            model="content-section"
            driver="builder"
            is-section
            :components="getBuilderComponents()"
            :search-params="searchParams"
            :readable-fields="['metaDescription', 'metaKeywords']"
        />
    </div>
    <!-- </layout> -->
</template>
